import { createStore, applyMiddleware } from "redux";
import thunkMiddleware from "redux-thunk";
import { createLogger } from "redux-logger";
import rootReducer from "../Reducers";

// Create a logger instance
const loggerMiddleware = createLogger({
  collapsed: true, // optional: collapses log groups
  duration: true,  // shows action duration
  timestamp: true  // adds timestamp
});

// Apply middleware in correct order
const Store = createStore(
  rootReducer,
  applyMiddleware(thunkMiddleware, loggerMiddleware)
);

export const getStoreState = (store) => {
  store = store || Store;
  return (store.getState && store.getState()) || {};
}

export default Store;
